import fetch from 'utils/fetch'

// 成人疫苗大类
export function fetchAdultVacc(params) {
  return fetch({
    url: '/reservation/vaccineV3/category/app/list/adult',
    params
  })
}

// 儿童疫苗大类
export function fetchChildVacc(params) {
  return fetch({
    url: '/reservation/vaccineV3/category/app/list/children',
    params
  })
}

// 其他疫苗大类
export function fetchVariuosVacc(params) {
  return fetch({
    url: '/reservation/vaccineV3/category/app/list/rabies',
    params
  })
}

// 疫苗小类
export function fetchVacc(params) {
  return fetch({
    url: '/reservation/vaccineV3/subclass/app/list',
    params
  })
}

// 疫苗告知书
export function fetchDeclaration(code) {
  return fetch({
    url: `/master/maDisclosure/code/${code}`
  })
}